import React from 'react';
import { useBlocksContext } from '/src/providers';
import { Carousel } from '/src/components';
import * as styles from './styles.scss';

const BlockSpecified = () => {
    const {
        headerSpecifiedBlock,
        isOpenHeaderSpecifiedBlock,
        setIsOpenHeaderSpecifiedBlock,
    } = useBlocksContext();

    return (
        (!!headerSpecifiedBlock?.length && isOpenHeaderSpecifiedBlock) &&
        <div className={styles.spec}>
            <Carousel
                showSlides={1}
                isShowArrows={false}
                isAutoSlide={headerSpecifiedBlock.length > 1}
                isShowPages={true}
            >
                {
                    headerSpecifiedBlock.map(({ uid, content: { html }}) => (
                        <div
                            key={uid}
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    ))
                }
            </Carousel>
            <button
                className={styles.close}
                onClick={() => setIsOpenHeaderSpecifiedBlock(false)}
                aria-label="Close"
            />
        </div>
    )
};

export default BlockSpecified;
